import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function RevSelection() {
  const [rev, setRev] = React.useState("");

  const handleChange = (event) => {
    setRev(event.target.value);
  };

  return (
    <Box sx={{ maxWidth: 200, m: "auto" }}>
      <FormControl fullWidth>
        <InputLabel id="rev-select-label" sx={{ fontSize: 18 }}>
          Revision
        </InputLabel>
        <Select
          labelId="rev-select-label"
          id="rev-select"
          value={rev}
          label="Revision"
          onChange={handleChange}
          sx={{ fontSize: 18 }}
        >
          <MenuItem value={1}>0</MenuItem>
          <MenuItem value={2}>1</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
